export default __webpack_public_path__ + "static/media/logo-bronce.67ba41f7.svg";